import React from "react";
import { useSnapshot } from "valtio";

import { CustomInput as Input } from "@components/Common/CustomInput";

import {
    computedStore,
    designStore,
    setPageInformationMessageItems,
    setInformationMessageItems,
} from "@store";
export function InformationMessageRow(): JSX.Element {
    const {
        selectedLanguage,
        informationMessageItems,
        activeSlideIndex,
    } = useSnapshot(designStore);

    const { elements } = useSnapshot(computedStore);

    function handleInformationMessageItemInputOnChangeEvent(content: string) {
        const localItems: HeaderLanguageItemsType = {
            ...informationMessageItems,
            [selectedLanguage]: {
                defaultContent:
                    informationMessageItems[selectedLanguage].defaultContent,
                content: content,
            },
        };
        setInformationMessageItems(localItems);
        setPageInformationMessageItems(
            localItems,
            elements[activeSlideIndex].name
        );
    }

    return (
        <tr>
            <td className="cursor__clz" style={{ width: "30%" }}>
                {informationMessageItems[selectedLanguage].defaultContent !==
                undefined
                    ? informationMessageItems[selectedLanguage].defaultContent
                    : null}
            </td>
            <td>
                <Input
                    value={
                        informationMessageItems[selectedLanguage].content !==
                        undefined
                            ? informationMessageItems[selectedLanguage].content
                            : undefined
                    }
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        return handleInformationMessageItemInputOnChangeEvent(
                            event.target.value
                        );
                    }}
                />
            </td>
        </tr>
    );
}
